import { useEffect, useState } from "react";
import { Row, Col, Form, Input } from "antd";
import MaskedInput from "antd-mask-input";
import { HJAddressSelectBox } from "@FORMS";

const { TextArea } = Input;

const Recipient = ({
  form,
  fieldName,
  onlySavedReceiversDeliveries,
  deliveryType,
}) => {
  const [cityId, setCityId] = useState(null);
  const [townId, setTownId] = useState(null);

  useEffect(() => {
    const values = form.getFieldsValue()[fieldName];
    if (values?.recipientCity) {
      setCityId(values.recipientCity);
    }
    if (values?.recipientTown) {
      setTownId(values.recipientTown);
    }
  }, [form]);

  return (
    <>
      <Row gutter={24}>
        <Col span={4}>
          <Form.Item
            name={[fieldName, "recipientName"]}
            label="Adı:"
            onKeyPress={(e) => {
              if (!/[a-zA-Z wığüşöçĞÜŞÖÇİ]/.test(e.key)) {
                e.preventDefault();
              }
            }}
            rules={[
              {
                required: true,
                message: "Lütfen geçerli ad giriniz!",
              },
            ]}
          >
            <Input maxLength={100} disabled={onlySavedReceiversDeliveries} />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            name={[fieldName, "recipientSurname"]}
            label="Soyadı:"
            onKeyPress={(e) => {
              if (!/[a-zA-Z wığüşöçĞÜŞÖÇİ]/.test(e.key)) {
                e.preventDefault();
              }
            }}
            rules={[
              {
                required: true,
                message: "Lütfen geçerli soyad giriniz!",
              },
            ]}
          >
            <Input maxLength={100} disabled={onlySavedReceiversDeliveries} />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            name={[fieldName, "recipientPhone"]}
            label="Telefon Numarası:"
            rules={[
              {
                required: true,
                message: "Lütfen cep telefonu numarası giriniz!",
              },
              () => ({
                validator(_, value) {
                  if (!value) {
                    return Promise.reject();
                  }
                  if (
                    value.includes("_") ||
                    /^[1-9][0-9]{9}$/.test(value.replace(/\s+/g, "")) === false
                  ) {
                    return Promise.reject(
                      new Error(
                        "Lütfen cep telefonu numarasını başında 0 olmadan 10 haneli olacak şekilde uygun bir formatta giriniz!"
                      )
                    );
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <MaskedInput
              mask="111 111 11 11"
              size="10"
              disabled={onlySavedReceiversDeliveries}
            />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            label="İl:"
            name={[fieldName, "recipientCity"]}
            rules={[
              {
                required: true,
                type: "object",
                message: "Lütfen il seçiniz",
              },
            ]}
          >
            <HJAddressSelectBox
              type="city"
              onChange={(val) => {
                let tempForm = form.getFieldsValue()[fieldName];
                let deliveryTypeVal = {
                  ...val,
                  deliveryType: deliveryType,
                };
                setCityId(deliveryTypeVal);
                setTownId(null);
                if (val?.forced) {
                  form.setFieldsValue({
                    [fieldName]: {
                      recipientTown: null,
                      recipientDistrict: null,
                    },
                  });
                }
              }}
              disabled={onlySavedReceiversDeliveries}
            />
          </Form.Item>
        </Col>

        <Col span={4}>
          <Form.Item
            label="İlçe:"
            name={[fieldName, "recipientTown"]}
            rules={[
              {
                required: true,
                type: "object",
                message: "Lütfen ilçe seçiniz",
              },
            ]}
          >
            <HJAddressSelectBox
              type="town"
              cityId={cityId}
              onChange={(val) => {
                let tempForm = form.getFieldsValue()[fieldName];
                let deliveryTypeVal = {
                  ...val,
                  deliveryType: deliveryType,
                };
                setTownId(deliveryTypeVal);
                if (val?.forced) {
                  form.setFieldsValue({
                    [fieldName]: {
                      recipientDistrict: null,
                    },
                  });
                }
              }}
              disabled={onlySavedReceiversDeliveries}
              deliveryType={deliveryType}
              form={form}
              fieldName={fieldName}
            />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            label="Mahalle:"
            name={[fieldName, "recipientDistrict"]}
            rules={[
              () => ({
                validator(_, value) {
                  if (typeof value === "string") {
                    form.setFieldsValue({
                      [fieldName]: { recipientDistrict: null },
                    });
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <HJAddressSelectBox
              type="district"
              townId={townId}
              disabled={onlySavedReceiversDeliveries}
              deliveryType={deliveryType}
              form={form}
              fieldName={fieldName}
            />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item
        label="Ev/İş Yeri Adresi:"
        name={[fieldName, "recipientAddressLine"]}
        rules={[
          {
            required: true,
            message: "Lütfen geçerli bir adres giriniz!",
          },
        ]}
      >
        <TextArea
          autoSize={{
            minRows: 1,
            maxRows: 3,
          }}
          maxLength={250}
          disabled={onlySavedReceiversDeliveries}
        />
      </Form.Item>
    </>
  );
};

export default Recipient;
